import type * as ngCore from '@angular/core'

import * as routeBound from '../route-bound'

import * as connectorDefinitions from './connector-definitions'
import * as connectors from './connectors'

export { connectorDefinitions, connectors }

/** Provides integration management collections for the active Admin route. */
export function provideAdminEntityCollections(): ngCore.Provider[] {
  return [
    connectorDefinitions.Api,
    routeBound.Registry.provideDestroyable(connectorDefinitions.Collection),
    connectors.Api,
    routeBound.Registry.provideDestroyable(connectors.Collection),
  ]
}

/** Provides connector execution state for the active portal app route. */
export function provideAppEntityCollections(): ngCore.Provider[] {
  return [
    connectorDefinitions.Api,
    routeBound.Registry.provideDestroyable(connectorDefinitions.Collection),
    connectors.Api,
    routeBound.Registry.provideDestroyable(connectors.Collection),
  ]
}
